import { useQuery } from '@tanstack/react-query';
import { getInstallationId, learnerApiJson, type GetToken } from '@/lib/learner-api';

export function useSupportUnread(getToken: GetToken | null) {
  return useQuery({
    queryKey: ['support-unread'],
    queryFn: async () => {
      const data = await learnerApiJson<{ unread: boolean }>(
        getToken,
        `/v1/support/unread?installation_id=${getInstallationId()}`,
      );
      return Boolean(data.unread);
    },
    refetchInterval: 60_000,
  });
}
